import http, { apiErrorMessage } from '../../http';

const vRutaTablero = 'tablero-control/';

export const getTableroResumen = (sucursal) => {
    return (dispatch, getState) => {
        dispatch({ type: "TABLERO_LOADING" });

        http.get(vRutaTablero + 'resumen', { params: { sucursal } })
            .then(function (response) {
                // Envelope v1: {data:{sucursal,metricas,metricas_hoy,...}}
                dispatch({
                    type: "TABLERO_RESUMEN_SUCCESS", payload: {
                        data: response.data.data,
                    }
                });
            })
            .catch(function (error) {
                dispatch({ type: 'TABLERO_RESUMEN_ERROR', payload: { error: apiErrorMessage(error) } });
            });
    }
}

export const getTableroDetalle = (sucursal, type, fecha = null) => {
    return (dispatch, getState) => {
        dispatch({ type: "TABLERO_DETALLE_LOADING" });
        var params = { sucursal, type };
        if (fecha) params.fecha = fecha;

        http.post(vRutaTablero + 'detalle', params)
            .then(function (response) {
                dispatch({
                    type: "TABLERO_DETALLE_SUCCESS", payload: {
                        data: response.data.data,
                    }
                });
            })
            .catch(function (error) {
                dispatch({ type: 'TABLERO_DETALLE_ERROR', payload: { error: apiErrorMessage(error) } });
            });
    }
}

export const limpiarDetalle = () => {
    return (dispatch) => {
        dispatch({ type: "TABLERO_DETALLE_LIMPIAR" });
    }
}

export const getTableroGuiasReparto = (sucursal, folioReparto) => {
    return (dispatch, getState) => {
        dispatch({ type: "TABLERO_GUIAS_REPARTO_LOADING" });

        http.get(vRutaTablero + 'repartos/' + encodeURIComponent(folioReparto) + '/guias', { params: { sucursal } })
            .then(function (response) {
                dispatch({
                    type: "TABLERO_GUIAS_REPARTO_SUCCESS", payload: {
                        data: response.data.data,
                    }
                });
            })
            .catch(function (error) {
                dispatch({ type: 'TABLERO_GUIAS_REPARTO_ERROR', payload: { error: apiErrorMessage(error) } });
            });
    }
}

export const limpiarGuiasReparto = () => {
    return (dispatch) => {
        dispatch({ type: "TABLERO_GUIAS_REPARTO_LIMPIAR" });
    }
}

export const getTableroEficiencia = (sucursal) => {
    return (dispatch, getState) => {
        dispatch({ type: "TABLERO_EFICIENCIA_LOADING" });

        http.get(vRutaTablero + 'eficiencia-historica', { params: { sucursal } })
            .then(function (response) {
                dispatch({
                    type: "TABLERO_EFICIENCIA_SUCCESS", payload: {
                        data: response.data.data,
                    }
                });
            })
            .catch(function (error) {
                dispatch({ type: 'TABLERO_EFICIENCIA_ERROR', payload: { error: apiErrorMessage(error) } });
            });
    }
}

export const getTableroGuiasEficiencia = (sucursal, filtroEstado) => {
    return (dispatch, getState) => {
        dispatch({ type: "TABLERO_GUIAS_EFICIENCIA_LOADING" });

        http.get(vRutaTablero + 'guias-eficiencia', { params: { sucursal, filtro_estado: filtroEstado } })
            .then(function (response) {
                dispatch({
                    type: "TABLERO_GUIAS_EFICIENCIA_SUCCESS", payload: {
                        data: response.data.data,
                    }
                });
            })
            .catch(function (error) {
                dispatch({ type: 'TABLERO_GUIAS_EFICIENCIA_ERROR', payload: { error: apiErrorMessage(error) } });
            });
    }
}

export const limpiarGuiasEficiencia = () => {
    return (dispatch) => {
        dispatch({ type: "TABLERO_GUIAS_EFICIENCIA_LIMPIAR" });
    }
}

export const getGuiaDetalles = (numeroGuia) => {
    return (dispatch, getState) => {
        dispatch({ type: "TABLERO_GUIA_DETALLES_LOADING" });

        http.get('monitoreo/guias/' + encodeURIComponent(numeroGuia))
            .then(function (response) {
                // Envelope v1: {data:{datos,...}} -> la vista lee .resultado.datos
                dispatch({
                    type: "TABLERO_GUIA_DETALLES_SUCCESS", payload: {
                        data: { resultado: response.data.data },
                    }
                });
            })
            .catch(function (error) {
                dispatch({ type: 'TABLERO_GUIA_DETALLES_ERROR', payload: { error: apiErrorMessage(error) } });
            });
    }
}

export const limpiarGuiaDetalles = () => {
    return (dispatch) => {
        dispatch({ type: "TABLERO_GUIA_DETALLES_LIMPIAR" });
    }
}
